/* Noser Groessentabellen - Renderer (Port der SizeChart-Komponente, vanilla JS) */
(function () {
  'use strict';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(root, productId, imgMap, lang) {
    var db = window.NoserSizeChartData;
    if (!db) return;
    var ui = db.ui, products = db.products, pantsLabels = db.pantsLabels;
    var p = products[productId];
    if (!p) return;

    var state = root._nscState || { lang: lang || 'de', sel: -1, measure: null };
    root._nscState = state;

    function t(o) { return o ? (o[state.lang] || '') : ''; }
    function img(name) { return imgMap[name] || ''; }

    var isTop = p.type === 'top';
    var isShirts = p.type === 'shirts';
    var isPants = p.type === 'pants';

    // Badges
    var badges = [];
    if (p.fit) badges.push(t(ui.fit) + ': ' + t(p.fit));
    if (isPants && p.id !== 'shorts') badges.push(t(ui.shrink));
    if (p.madeInEU) badges.push(t(ui.madeInEU));

    // Tabellen normalisieren
    function sketchHtml(src, fitLabel) {
      if (!src) return '';
      var cap = t(ui.sketch) + (fitLabel ? ' — ' + fitLabel : '');
      return '<div class="nsc__sketchbox"><img src="' + img(src) + '" alt="' + esc(t(ui.sketch)) + '" loading="lazy"><span class="nsc__sketchcap">' + esc(cap) + '</span></div>';
    }
    function tableHtml(label, firstHead, cols, rows, withK, selectable, sketch) {
      var h = '';
      if (label) h += '<div class="nsc__fitlabel">' + esc(label) + '</div>';
      h += sketchHtml(sketch, label);
      h += '<div class="nsc__twrap"><table class="nsc__table"><thead><tr>';
      h += '<th class="nsc__sticky">' + esc(firstHead) + '</th>';
      cols.forEach(function (c, i) {
        h += '<th' + (selectable ? ' data-col="' + i + '"' : '') + '>' + esc(c) + '</th>';
      });
      h += '</tr></thead><tbody>';
      rows.forEach(function (r) {
        h += '<tr><td class="nsc__sticky">';
        if (withK && r.k) h += '<span class="nsc__rowkey">' + esc(r.k) + '</span>';
        h += esc(t(r.label)) + '</td>';
        r.v.forEach(function (v, i) {
          h += '<td' + (selectable ? ' data-col="' + i + '"' : '') + '>' + esc(v) + '</td>';
        });
        h += '</tr>';
      });
      h += '</tbody></table></div>';
      return '<div class="nsc__tblock">' + h + '</div>';
    }

    var tablesHtml = '';
    if (isTop) {
      tablesHtml = tableHtml(null, t(ui.size), p.sizes, p.rows, true, true, p.sketch);
    } else if (isShirts) {
      p.fits.forEach(function (f) {
        tablesHtml += tableHtml(t(f.label), t(ui.size), f.sizes, f.rows, true, false, f.sketch);
      });
    } else if (isPants) {
      var rows = [
        { k: '', label: pantsLabels.konf, v: p.konf },
        { k: '', label: pantsLabels.cm, v: p.bundCm },
      ];
      tablesHtml = tableHtml(null, t(pantsLabels.w), p.wSizes, rows, false, true);
      if (p.inseam) {
        var inseamRows = [{ k: '', label: ui.inseam, v: p.inseam.map(function (x) { return x.cm; }) }];
        tablesHtml += tableHtml(null, t(pantsLabels.schritt), p.inseam.map(function (x) { return x.l; }), inseamRows, false, false);
      } else if (p.inseamFixed) {
        tablesHtml += '<div class="nsc__tblock"><div class="nsc__twrap"><table class="nsc__table" style="min-width:0"><thead><tr><th class="nsc__sticky">' + esc(t(pantsLabels.schritt)) + '</th><th>' + esc(t(p.inseamFixed)) + '</th></tr></thead></table></div></div>';
      }
    }

    // Chips
    var chipSrc = isTop ? p.sizes : (isPants ? p.wSizes : []);
    var chipsHtml = '';
    if (chipSrc.length) {
      chipsHtml = '<div class="nsc__chips">' + chipSrc.map(function (s, i) {
        return '<button type="button" class="nsc__chip" data-chip="' + i + '">' + esc(s) + '</button>';
      }).join('') + '</div><div class="nsc__chiphint">' + esc(t(ui.selectHint)) + '</div>';
    }

    var advisorLabel = isPants ? t(pantsLabels.cm) : (p.advisor && t(p.advisor.label));

    var html = '';
    html += '<div class="nsc">';
    html += '<div class="nsc__topbar">';
    html += '<img class="nsc__wordmark" src="' + img('size-chart-noser-wordmark.png') + '" alt="NOSER">';
    html += '<div class="nsc__langs">';
    html += '<button type="button" class="nsc__lang' + (state.lang === 'de' ? ' is-active' : '') + '" data-lang="de">DE</button>';
    html += '<button type="button" class="nsc__lang' + (state.lang === 'en' ? ' is-active' : '') + '" data-lang="en">EN</button>';
    html += '</div></div>';
    html += '<div class="nsc__card">';
    html += '<div class="nsc__eyebrow">' + esc(t(ui.eyebrow)) + '</div>';
    html += '<h1 class="nsc__title">' + esc(t(p.title)) + '</h1>';
    if (badges.length) {
      html += '<div class="nsc__badges">' + badges.map(function (b) { return '<span class="nsc__badge">' + esc(b) + '</span>'; }).join('') + '</div>';
    }
    if (p.note) html += '<div class="nsc__note">' + esc(t(p.note)) + '</div>';
    html += '<div class="nsc__main">';
    if (p.image) {
      html += '<div class="nsc__imgbox"><img src="' + img(p.image) + '" alt="' + esc(t(p.title)) + '" loading="lazy"></div>';
    }
    html += '<div><div class="nsc__mhead"><h2 class="nsc__h2">' + esc(t(ui.measurements)) + '</h2><span class="nsc__allcm">' + esc(t(ui.allCm)) + '</span></div>';
    html += chipsHtml;
    html += '</div></div>';
    html += tablesHtml;
    // Grössenberater
    html += '<div class="nsc__advisor">';
    html += '<div class="nsc__advisor-title">' + esc(t(ui.advisorTitle)) + '</div>';
    html += '<div class="nsc__advisor-hint">' + esc(t(ui.advisorHint)) + '</div>';
    html += '<div class="nsc__advisor-row"><label class="nsc__advisor-label">' + esc(advisorLabel || '') + '</label>';
    html += '<div class="nsc__advisor-input"><input type="number" inputmode="decimal" min="40" max="200" placeholder="' + esc(t(ui.advisorPlaceholder)) + '"><span>cm</span></div></div>';
    html += '<div class="nsc__advisor-out"></div>';
    html += '</div>';
    // Messanleitung
    if (p.measures && p.measures.length) {
      html += '<h2 class="nsc__howto">' + esc(t(ui.howto)) + '</h2><div class="nsc__measures">';
      p.measures.forEach(function (m) {
        html += '<div class="nsc__measure"><img src="' + img(m.img) + '" alt="' + esc(t(m.title)) + '" loading="lazy">';
        html += '<div class="nsc__measure-title">' + esc(t(m.title)) + '</div>';
        html += '<div class="nsc__measure-text">' + esc(t(m.text)) + '</div></div>';
      });
      html += '</div>';
    }
    html += '<div class="nsc__hinweis">' + esc(t(p.hinweis)) + '</div>';
    if (p.care) html += '<div class="nsc__subblock"><div class="nsc__subblock-title">' + esc(t(ui.care)) + '</div><div class="nsc__subblock-text">' + esc(t(p.care)) + '</div></div>';
    if (p.material) html += '<div class="nsc__subblock"><div class="nsc__subblock-title">' + esc(t(ui.material)) + '</div><div class="nsc__material-text">' + esc(t(p.material)) + '</div></div>';
    if (p.eu) html += '<div class="nsc__eu">' + esc(t(p.eu)) + '</div>';
    html += '</div>'; // card
    html += '<div class="nsc__footer"><span>' + esc(t(p.date)) + '</span><span>' + esc(t(ui.step)) + '</span><a href="https://www.noser-fashion.com" target="_blank" rel="noopener">www.noser-fashion.com</a></div>';
    html += '</div>';

    root.innerHTML = html;

    // ---- Interaktionen ----
    function applySel() {
      root.querySelectorAll('.nsc__chip').forEach(function (ch) {
        ch.classList.toggle('is-active', parseInt(ch.dataset.chip, 10) === state.sel);
      });
      root.querySelectorAll('[data-col]').forEach(function (cell) {
        cell.classList.toggle('is-sel', parseInt(cell.dataset.col, 10) === state.sel);
      });
    }
    root.querySelectorAll('.nsc__chip').forEach(function (ch) {
      ch.addEventListener('click', function () {
        var i = parseInt(ch.dataset.chip, 10);
        state.sel = state.sel === i ? -1 : i;
        applySel();
      });
    });
    applySel();

    root.querySelectorAll('.nsc__lang').forEach(function (b) {
      b.addEventListener('click', function () {
        if (state.lang === b.dataset.lang) return;
        state.lang = b.dataset.lang;
        render(root, productId, imgMap, state.lang);
      });
    });

    // Grössenberater
    var input = root.querySelector('.nsc__advisor-input input');
    var out = root.querySelector('.nsc__advisor-out');
    function updateAdvisor() {
      var m = parseFloat(input.value);
      state.measure = isNaN(m) ? null : m;
      if (state.measure == null || state.measure <= 0) { out.innerHTML = ''; return; }
      var results = [];
      function findSize(sizes, values) {
        for (var i = 0; i < values.length; i++) if (values[i] >= state.measure) return String(sizes[i]);
        return null;
      }
      if (isTop) {
        var row = p.rows[p.advisor.rowIndex];
        var s = findSize(p.sizes, row.v);
        if (s) results.push(s);
      } else if (isShirts) {
        p.fits.forEach(function (f) {
          var r2 = f.rows[p.advisor.rowIndex];
          var s2 = findSize(f.sizes, r2.v);
          if (s2) results.push(t(f.label) + ': ' + s2);
        });
      } else if (isPants) {
        var s3 = findSize(p.wSizes, p.bundCm);
        if (s3) results.push('W' + s3);
      }
      if (results.length) {
        out.innerHTML = '<div class="nsc__advisor-results"><span class="nsc__advisor-results-label">' + esc(t(ui.advisorResult)) + ':</span>' +
          results.map(function (r) { return '<span class="nsc__advisor-pill">' + esc(r) + '</span>'; }).join('') + '</div>';
      } else {
        out.innerHTML = '<div class="nsc__advisor-none">' + esc(t(ui.advisorNone)) + '</div>';
      }
    }
    input.addEventListener('input', updateAdvisor);
    if (state.measure != null) { input.value = state.measure; updateAdvisor(); }
  }

  window.NoserSizeChart = { render: render };
})();
